export default "data:video/mp2t;base64,aW1wb3J0IHsgdXNlVG9hc3QsIHRvYXN0IH0gZnJvbSAiQC9ob29rcy91c2UtdG9hc3QiOwoKZXhwb3J0IHsgdXNlVG9hc3QsIHRvYXN0IH07Cg=="